import { ReactElement } from 'react'
import { useParams } from 'react-router'
import { ProjectApplicationAssessmentSummary } from 'src/screens/shared/application/assessment/details/summary/ProjectApplicationAssessmentSummary'

export const PfKapAssessmentDetailsSummaryPage = (): ReactElement => {
  const { projectId, assessmentId } = useParams()
  const pf_kap_project_id = parseInt(projectId as string)
  const pf_kap_assessment_id = parseInt(assessmentId as string)

  return (
    <ProjectApplicationAssessmentSummary
      baseUrl="/pf-kap"
      projectId={pf_kap_project_id}
      assessmentId={pf_kap_assessment_id}
    />
  )
}
